import React, { memo } from "react";

function AppCard({ app, imgHeight = "h-40" }) {
  return (
    <div className="cardWidth flex flex-col space-y-1">
      <div className="relative">
        <img
          alt="app"
          src={app.coverImageUrl || `${process.env.PUBLIC_URL}/images/user.png`}
          className={`rounded-xl ${imgHeight}  w-full object-cover bg-primary`}
          loading="lazy"
        />
      </div>
      <p className="custom-line-clamp font-medium text-navyGray dark:text-frescoWhite text-base	">
        {app.name}
      </p>
      {app.reviewedCount && app.reviewedCount > 0 && (
        <div className="text-darkGray">
          <p className="text-sm">
            {app.reviewedCount}{" "}
            {app.reviewedCount === 1 ? "response" : "responses"}
          </p>
        </div>
      )}
    </div>
  );
}

function areEqual(prevProps, nextProps) {
  return prevProps.app === nextProps.app;
}
export default memo(AppCard, areEqual);
